// extracted by mini-css-extract-plugin
module.exports = {"panel":"index_panel__3lkMW","navigator":"index_navigator__14QKX"};